import { compatibility, type Language } from '@seek/ca-myprofile-utils';

export const getLanguagePrefixedPath = (
  language: Language = 'en',
  basePath: string = '',
): string => {
  const compatibleLanguage =
    compatibility.getCompatibleLanguageFromLocaleString(language);
  return compatibleLanguage === 'en'
    ? basePath
    : `/${compatibleLanguage}${basePath}`;
};
